module.exports = __webpack_public_path__ + "img/photo4.e0c573ce.png";